define.alias("shared/components/shared/post/profile-selector/available-profile", "media/components/shared/post/profile-selector/available-profile/index");